export default "__VITE_ASSET__C7tl$S$I__"